import { useState } from "react";
import { ReactLenis } from "lenis/react";
import axios from "axios";
import { toast } from "sonner";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import ProductSection from "@/components/ProductSection";
import Manifesto from "@/components/Manifesto";
import CoolingTech from "@/components/CoolingTech";
import Reviews from "@/components/Reviews";
import FAQ from "@/components/FAQ";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
import StickyBuyBar from "@/components/StickyBuyBar";
import { Toaster } from "@/components/ui/sonner";
import { VARIANTS } from "@/data/product";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function App() {
    const [variantId, setVariantId] = useState("white-fridge");
    const [quantity, setQuantity] = useState(1);
    const [bundle, setBundle] = useState(false);
    const [buying, setBuying] = useState(false);

    const variant = VARIANTS.find((v) => v.id === variantId);

    const buyNow = async () => {
        setBuying(true);
        try {
            const { data } = await axios.post(`${API}/shopify/checkout`, { variant_id: variantId, quantity, bundle });
            window.location.href = data.checkout_url;
        } catch (err) {
            toast.error(err.response?.data?.detail || "Checkout is not available right now. Please try again.");
            setBuying(false);
        }
    };

    return (
        <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
            <div className="noise bg-[#0A0A0A] text-white min-h-screen overflow-x-hidden">
                <Navbar onBuy={buyNow} />
                <main>
                    <Hero onBuy={buyNow} />
                    <EditorialMarquee />
                    <ProductSection
                        variantId={variantId}
                        setVariantId={setVariantId}
                        quantity={quantity}
                        setQuantity={setQuantity}
                        bundle={bundle}
                        setBundle={setBundle}
                        buying={buying}
                        onBuy={buyNow}
                    />
                    <Manifesto />
                    <CoolingTech />
                    <Reviews />
                    <FAQ />
                    <FinalCTA onBuy={buyNow} />
                </main>
                <Footer />
                <StickyBuyBar variant={variant} onBuy={buyNow} />
                <Toaster theme="dark" position="top-center" />
            </div>
        </ReactLenis>
    );
}
